import { render, staticRenderFns } from "./IssueSettings.vue?vue&type=template&id=154dd044&"
import script from "./IssueSettings.vue?vue&type=script&lang=js&"
export * from "./IssueSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports